import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { sendOnLoadingRetry } from 'my-purchases/utils/analytics/analyticsEvents'
import { useMemo } from 'react'

import styles from './RetryPartialError.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface RetryPartialErrorProps {
	readonly retryFn?: () => void
	readonly active: boolean
	readonly fullError: boolean
}

export function RetryPartialError({
	retryFn,
	active,
	fullError,
}: RetryPartialErrorProps) {
	const { t } = useLabels()

	const handleRetryLoad = () => {
		sendOnLoadingRetry()
		retryFn?.()
	}

	const message = useMemo(() => {
		if (fullError) {
			return active
				? t('myPurchases.errorActive.bodycopy.allPurchases')
				: t('myPurchases.errorHistory.bodycopy.allPurchases')
		}
		return active
			? t('myPurchases.errorActive.bodycopy.somePurchases')
			: t('myPurchases.errorHistory.bodycopy.somePurchases')
	}, [fullError, active])

	return (
		<div className={styles.wrapper}>
			<ClientLabel
				paragraphProps={{
					onClick: handleRetryLoad,
					className: `${text.bodyMRegularUnderline} ${styles.retry}`,
				}}
			>
				{message}
			</ClientLabel>
		</div>
	)
}
